<div class="popup-content relative o-hidden box-popup">
    <div class="rounded-t relative text-light-shadow-v2 text-center tw-overflow-auto">
        <div class="d-flex align-items-center title">
            <div class="text-light-shadow-v2 text-22 font-bold text-center w-100" translate>v3-global-help-admin-support</div>
            <button class="ms-auto" [attr.aria-label]="'v3-button-close' | translate" (click)="close('close')" buttonDataTest="closeButton">
                <app-icon name="x" class="tw-w-3.5 tw-h-3.5"></app-icon>
            </button>
        </div>

        <div class="text-m support-link font-medium">
            <span translate>v3-company-admin-support-popup-link</span>
            <a href="https://help.socialtalent.com/stpkb/" target="_blank" class="tw-cursor-pointer tw-underline" [style.color]="'#3684E7'" translate>
                v3-company-admin-support-popup-knowledge-base
            </a>
        </div>

        <div class="text-m info-box text-left">
            <div class="info font-medium" [innerHTML]="'v3-company-admin-support-popup-info' | translate" translate></div>
            <div class="font-bold mb-2" translate>v3-company-admin-support-popup-info-1</div>
            <div class="font-bold mb-2" translate>v3-company-admin-support-popup-info-2</div>
            <div class="font-bold" translate>v3-company-admin-support-popup-info-3</div>
        </div>

        <div class="text-m font-bold text-left your-company-admins" translate>v3-company-admin-support-popup-your-company-admins</div>

        <div>
            <app-company-admin-support-popup-table-user-filters></app-company-admin-support-popup-table-user-filters>
            <div
                *ngIf="companyAdmins$ | async as companyAdmins"
                #ps
                class="ps relative admins-container"
                [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }"
            >
                <app-company-admin-support-popup-table-user-row
                    *ngFor="let admin of companyAdmins"
                    [admin]="admin"
                ></app-company-admin-support-popup-table-user-row>
            </div>
            <div *ngIf="(loaded$ | async) === false" class="my-4">
                <app-loader loaderSize="s"></app-loader>
            </div>
        </div>

        <div class="theme-new relative">
            <button
                *ngIf="(selectedAdminsEmails$ | async)?.length > 1"
                [ngbTooltip]="'v3-company-admin-support-popup-addresses-copied' | translate"
                container="body"
                [autoClose]="false"
                tooltipClass="tooltip-white"
                triggers="manual"
                (mouseleave)="onMouseLeave()"
                (click)="copySelectedEmails()"
                #tootlipCopySelectedEmails="ngbTooltip"
                buttonDataTest="copyEmailsButton"
                app-button
                size="md"
                severity="primary"
                icon="bookmarks"
                iconPosition="left"
                [text]="
                    (selectedAdminsEmails$ | async)?.length === (companyAdmins$ | async)?.length
                        ? ('v3-company-admin-support-popup-copy-all-emails' | translate)
                        : ('v3-company-admin-support-popup-copy-seleced-email' | translate)
                "
            ></button>
        </div>

        <div [style.margin-top.rem]="(selectedAdminsEmails$ | async)?.length > 1 ? '1.5' : '4.375'">
            <div
                app-button-outline
                size="md"
                severity="secondary"
                [text]="'v3-button-close' | translate"
                role="button"
                tabindex="0"
                (keyup.enter)="close('close')"
                (keyup.space)="close('close')"
                (click)="close('close')"
            ></div>
        </div>
    </div>
</div>
